import { useEffect, useState } from 'react';
import { Combobox, TextInput, useCombobox } from '@mantine/core';

import { TimeOption } from 'components/MenuManagement/MenuEdit/Hours/types';

import { ChevronDownIconSm } from '@chownow/pantry/icons';

type TimeSelectProps = {
  disabled?: boolean;
  flex?: number | string;
  onSelectNewTime: (value: string) => void;
  timeOptions: TimeOption[];
  value: string;
  w?: number | string;
  error?: string | boolean;
};

function TimeSelect({
  disabled,
  flex,
  onSelectNewTime,
  timeOptions,
  value,
  w,
  error,
}: TimeSelectProps) {
  const combobox = useCombobox();

  const [textInputValue, setTextInputValue] = useState(value);

  useEffect(() => {
    setTextInputValue(value);
  }, [value]);

  const shouldFilterOptions = textInputValue !== value;
  const filteredOptions = shouldFilterOptions
    ? timeOptions.filter(option =>
        option.displayValue?.toLowerCase().includes(textInputValue?.toLowerCase().trim()),
      )
    : timeOptions;

  return (
    <Combobox
      onOptionSubmit={optionValue => {
        onSelectNewTime(optionValue);
        combobox.closeDropdown();
      }}
      store={combobox}
      width="max-content"
      {...(flex ? { style: { flex } } : {})}
    >
      <Combobox.Target>
        <TextInput
          rightSectionPointerEvents="none"
          rightSection={<ChevronDownIconSm />}
          disabled={disabled}
          value={textInputValue}
          onChange={event => {
            setTextInputValue(event.currentTarget.value);
            combobox.openDropdown();
            combobox.updateSelectedOptionIndex();
          }}
          onClick={() => combobox.openDropdown()}
          onFocus={() => combobox.openDropdown()}
          onBlur={() => {
            setTextInputValue(value);
            combobox.closeDropdown();
          }}
          w={w}
          size="sm"
          error={!!error}
          styles={{ input: { textOverflow: 'ellipsis' } }}
        />
      </Combobox.Target>

      <Combobox.Dropdown p="xs2" miw={w ?? 120} style={{ maxHeight: '300px', overflow: 'auto' }}>
        <Combobox.Options>
          {filteredOptions.map(item => (
            <Combobox.Option
              value={item.displayValue}
              key={item.displayValue}
              p="sm"
              style={{ whiteSpace: 'nowrap' }}
            >
              {item.displayValue}
            </Combobox.Option>
          ))}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
}

export default TimeSelect;
